import * as ROLES from '../constants/roles';
import { AuthUser } from '../firebase/firebase';

export const loggedIn = (authUser: AuthUser) => !!authUser.email;
export const isAdmin = (authUser: AuthUser) => authUser.roles && !!authUser.roles[ROLES.ADMIN];
